module.exports = __webpack_public_path__ + "static/ashleybeattie-41500ba1cc3b59f326221b8c750a067d.png";